import { globals } from "@src/utils/globals.js";

const PLATES = {
    PT: {
        dataSourceId: globals.DATASOURCE.PT,
        mask: "XX-XX-XX",
        placeholder: "00-AA-00",
        regex: /^(([A-Z]{2}-\d{2}-(\d{2}|[A-Z]{2}))|(\d{2}-(\d{2}-[A-Z]{2}|[A-Z]{2}-\d{2})))$/i,
        format: (plate) =>
            `${plate.substring(0, 2)}-${plate.substring(
                2,
                4
            )}-${plate.substring(4)}`,
    },
    ES: {
        dataSourceId: globals.DATASOURCE.ES,
        mask: "XXXX XXX",
        placeholder: "0000 AAA",
        regex: /^(\d{4} [A-Z]{3})$/i,
        format: (plate) => `${plate.substring(0, 4)} ${plate.substring(4)}`,
    },
    FR: {
        dataSourceId: globals.DATASOURCE.FR,
        mask: "XX-XXX-XX",
        placeholder: "00-AAA-00",
        regex: /^([A-Z]{2}-\d{3}-[A-Z]{2})$/i,
        format: (plate) =>
            `${plate.substring(0, 2)}-${plate.substring(
                2,
                5
            )}-${plate.substring(5)}`,
    },
    IT: {
        dataSourceId: globals.DATASOURCE.IT,
        mask: "XX XXXXX",
        placeholder: "AA 000AA",
        regex: /^([A-Z]{2} \d{3}[A-Z]{2})$/i,
        format: (plate) => `${plate.substring(0, 2)} ${plate.substring(2)}`,
    },
};

export function getPlaceholder(dataSourceId) {
    let countryCode = getCountryCodeByDataSourceId(dataSourceId);
    return countryCode && PLATES[countryCode]
        ? PLATES[countryCode].placeholder
        : "";
}

export function getMask(dataSourceId) {
    if (!dataSourceId) return "";
    let countryCode = getCountryCodeByDataSourceId(dataSourceId);
    return countryCode && PLATES[countryCode] ? PLATES[countryCode].mask : "";
}

export function validPlate(countryCode, plate) {
    return countryCode && PLATES[countryCode]
        ? PLATES[countryCode].regex.test(plate)
        : "";
}

export function formatPlate(dataSourceId, plate) {
    let countryCode = getCountryCodeByDataSourceId(dataSourceId);
    plate = trimPlate(plate);
    return countryCode && PLATES[countryCode]
        ? PLATES[countryCode].format(plate).toUpperCase()
        : "";
}

export function trimPlate(plate) {
    return plate ? plate.replace(/-/g, "").replace(/\s/g, "") : "";
}

export function getCountryCodeByDataSourceId(dataSourceId) {
    return Object.keys(PLATES).find(
        (o) => PLATES[o].dataSourceId == dataSourceId
    );
}

export function validPlateSize(dataSourceId, plate) {
    let countryCode = getCountryCodeByDataSourceId(dataSourceId);
    return (
        plate !== null &&
        PLATES[countryCode].placeholder &&
        PLATES[countryCode].placeholder.length == plate.length
    );
}

export function getDataSourceIdByLanguageCode(languageCode) {
    return languageCode && PLATES[languageCode.toUpperCase()]
        ? PLATES[languageCode.toUpperCase()].dataSourceId
        : PLATES["PT"].dataSourceId;
}

export function getDataSourceDisplay(dataSourceId) {
    const getDS = getCountryCodeByDataSourceId(dataSourceId);
    return getDS.substring(0, 1);
}
